export default __webpack_public_path__ + "static/media/alphacrypto.b0ca16dd.svg";